import api from '../api/endpoints';
import { requestLocationPermission, getCurrentPosition, lastPositionError } from './location';

/**
 * Read the browser position, store it on the server, and name it. Dispatch
 * rings from the position the SERVER holds, so this pushes before it reports
 * success. Resolves { error } rather than throwing.
 */
export const syncRiderLocation = async ({ fresh = false } = {}) => {
  const ok = await requestLocationPermission();
  if (!ok) return { error: 'permission' };
  const fix = await getCurrentPosition({ fresh });
  if (!fix || !fix.coordinates) {
    const code = lastPositionError();
    return { error: code === 1 ? 'permission' : code === 3 ? 'timeout' : 'nofix' };
  }

  let server;
  try {
    server = (await api.rides.heartbeat({ coordinates: fix.coordinates, accuracy: fix.accuracy })).data;
  } catch (e) {
    return { error: 'server', message: e.message, coordinates: fix.coordinates };
  }

  let address = '';
  let city = '';
  try {
    const a = (await api.maps.reverse({ lat: fix.coordinates[1], lng: fix.coordinates[0] })).data || {};
    address = a.address || '';
    city = [a.city, a.state].filter(Boolean).join(', ');
  } catch (e) { /* the pin is saved even if we cannot name it */ }

  return {
    coordinates: fix.coordinates,
    accuracy: fix.accuracy ? Math.round(fix.accuracy) : null,
    address,
    city,
    updatedAt: (server && server.updatedAt) || new Date().toISOString(),
    radiusKm: server && server.radiusKm,
  };
};

export const LOCATION_ERRORS = {
  permission: 'Location permission is blocked. Allow it in the browser so orders near you can ring.',
  timeout: 'Getting your position took too long. Move near a window or outdoors and refetch.',
  nofix: 'Could not get your position. Turn on location and refetch.',
  server: 'Got your position but could not save it. Check your internet and refetch.',
};

export default syncRiderLocation;
